export type NativeEventValue = string | number | object;

const getWebkit = () => (typeof window !== 'undefined' ? (window as any).webkit : undefined);

export const logEvent = (name: string) => {
	if (!name) {
		return;
	}
	if ((window as any).AnalyticsWebInterface) {
		// Call Android interface
		(window as any).AnalyticsWebInterface.logEvent(name);
	} else {
		const webkit = getWebkit();
		if (webkit && webkit.messageHandlers && webkit.messageHandlers.firebase) {
			const message = { command: 'logEvent', name };
			webkit.messageHandlers.firebase.postMessage(message);
		} else {
			console.log('No native APIs found ' + name);
		}
	}
};

export const logEventWithValues = (name: string, value: NativeEventValue) => {
	if (!name || !value) {
		return;
	}
	const json = JSON.stringify(value);
	if ((window as any).AnalyticsWebInterface) {
		// Call Android interface
		(window as any).AnalyticsWebInterface.logEvent(name, json);
	} else {
		const webkit = getWebkit();
		if (webkit && webkit.messageHandlers && webkit.messageHandlers.firebase) {
			const message = { command: 'logEvent', name, value: json };
			webkit.messageHandlers.firebase.postMessage(message);
		} else {
			console.log('No native APIs found ' + name);
		}
	}
};

export const setNativeInterface = (name: string) => {
	if (!name) {
		return;
	}
	if ((window as any).AnalyticsWebInterface) {
		// Call Android interface
		(window as any).AnalyticsWebInterface.setNativeInterface(name);
	} else {
		const webkit = getWebkit();
		if (webkit && webkit.messageHandlers && webkit.messageHandlers.firebase) {
			const message = { command: 'setNativeInterface', name };
			webkit.messageHandlers.firebase.postMessage(message);
		} else {
			console.log('No native APIs found ' + name);
		}
	}
};
